





































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import BaseModal from './ui/BaseModal.vue'
import InformationWebsite from '@/data/information-website'
import InformationWebsiteTab from '@/data/information-website-tab'
import TabThickness from './tabs/TabThickness.vue'
import TabCoating from './tabs/TabCoating.vue'
import TabPhotoChromic from './tabs/TabPhotoChromic.vue'

@Component({
  components: {
    BaseModal,
    TabThickness,
    TabCoating,
    TabPhotoChromic
  }
})
export default class InformationPopup extends Vue {
  @Prop() private code!: string
  @Prop() private info?: InformationWebsite
  @Prop() private contentPath?: string

  private currentTabComponent: number = 0
  private publicPath: string = this.$store.state.offlineMode
    ? `${process.env.BASE_URL}${this.contentPath}`
    : `${this.$config.url}${this.contentPath}`
  private showModal: boolean = false

  private get infoWebsite (): InformationWebsite | undefined {
    if (this.info) {
      return this.info
    } else {
      return this.$store.state.data.popups.find((popup: InformationWebsite) => popup.code === this.code)
    }
  }

  private tabClicked (index: number) {
    this.currentTabComponent = index
  }

  private get tabs (): InformationWebsiteTab[] {
    if (this.infoWebsite) {
      return this.infoWebsite.tabs
    }
    return [{
      content: this.code,
      sortOrder: 0
    }]
  }

  private get debug () {
    return this.$store.state.debug
  }

  private get title (): string {
    if (this.infoWebsite && String(this.infoWebsite.title).length) {
      return String(this.infoWebsite.title)
    }
    return ''
  }
}
